import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, createVNode as _createVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b92c4106"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "rvwa" }
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<div class=\"rvwa__block\" style=\"padding-bottom:1rem;\" data-v-b92c4106><div class=\"container\" data-v-b92c4106><h1 class=\"rvwa__title\" data-v-b92c4106> ФСРО «Ассоциация виноградарей и виноделов России» </h1><p class=\"rvwa__description\" data-v-b92c4106> Ассоциация виноградарей и виноделов России является объединением виноградарских и (или) винодельческих хозяйств, имеющих в собственности или на ином законном основании виноградные насаждения </p><p class=\"rvwa__description rvwa__description--small\" data-v-b92c4106> Официальный сайт ФСРО: <a class=\"rvwa__link\" href=\"https://rvwa.ru/\" target=\"_blank\" rel=\"noreferrer noopener nofollow\" data-v-b92c4106>https://rvwa.ru/</a></p></div></div>", 1)
const _hoisted_3 = {
  class: "rvwa__block",
  style: {"padding":"0"}
}
const _hoisted_4 = { class: "container" }
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "rvwa__block" }
const _hoisted_7 = { class: "container" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "rvwa__subtitle" }, "Цели ассоциации", -1))
const _hoisted_9 = { class: "targets" }
const _hoisted_10 = { class: "targets__item" }
const _hoisted_11 = ["innerHTML"]
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "targets__description" }, [
  /*#__PURE__*/_createTextVNode(" Повышение "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("качества продукции виноградарства и виноделия в Российской Федерации ")
], -1))
const _hoisted_13 = { class: "targets__item" }
const _hoisted_14 = ["innerHTML"]
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "targets__description" }, [
  /*#__PURE__*/_createTextVNode(" Повышение "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("конкурентоспособности российской продукции виноградарства, а также продукции виноделия ")
], -1))
const _hoisted_16 = { class: "targets__item" }
const _hoisted_17 = ["innerHTML"]
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "targets__description" }, " Обеспечение и защита прав граждан на безопасность продукции виноградарства и виноделия ", -1))
const _hoisted_19 = { class: "targets__item" }
const _hoisted_20 = ["innerHTML"]
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "targets__description" }, " Стимулирование развития виноградарства и виноделия в Российской Федерации ", -1))
const _hoisted_22 = { class: "targets__item" }
const _hoisted_23 = ["innerHTML"]
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "targets__description" }, " Установление деловых, творческих и производственных контактов между членами Ассоциации ", -1))
const _hoisted_25 = { class: "targets__item" }
const _hoisted_26 = ["innerHTML"]
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "targets__description" }, " Совершенствование регулирования рынка продукции виноградарства и виноделия ", -1))
const _hoisted_28 = { class: "rvwa__block" }
const _hoisted_29 = { class: "container" }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "rvwa__subtitle" }, "Виноделы, входящие в ассоциацию виноградарей и виноделов России", -1))

import { computed, onMounted } from 'vue'
import icons from '@/shared/assets/icons/icons'
import MemberListRVWA from '@/pages/RVWA/ui/MemberListRVWA.vue'
import { useAppStore } from '@/shared/config/storeConfig/storeConfig'
import { setBreadcrumbs } from '@/features/Breadcrumbs'


export default /*#__PURE__*/_defineComponent({
  __name: 'LandingRVWA',
  setup(__props) {

const store = useAppStore()
const members = computed(() => store.state.rvwa.members)

const getIcon = (name: string) => icons.solid[name]

const breadcrumbs = [
	{ path: '/', name: 'Главная' },
	{
		path: '/rvwa',
		name: 'Ассоциация виноградарей и виноделов России'
	}
]

onMounted(() => {
	setBreadcrumbs(breadcrumbs)
	store.dispatch('rvwa/getRvwaMembersList')
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("img", {
          class: "rvwa__background",
          src: require('../assets/background.jpg'),
          alt: "Бочки"
        }, null, 8, _hoisted_5)
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        _hoisted_8,
        _createElementVNode("ul", _hoisted_9, [
          _createElementVNode("li", _hoisted_10, [
            _createElementVNode("div", {
              class: "targets__img",
              innerHTML: getIcon( 'cup')
            }, null, 8, _hoisted_11),
            _hoisted_12
          ]),
          _createElementVNode("li", _hoisted_13, [
            _createElementVNode("div", {
              class: "targets__img",
              innerHTML: getIcon( 'globe')
            }, null, 8, _hoisted_14),
            _hoisted_15
          ]),
          _createElementVNode("li", _hoisted_16, [
            _createElementVNode("div", {
              class: "targets__img",
              innerHTML: getIcon( 'heart')
            }, null, 8, _hoisted_17),
            _hoisted_18
          ]),
          _createElementVNode("li", _hoisted_19, [
            _createElementVNode("div", {
              class: "targets__img",
              innerHTML: getIcon( 'bookOpen')
            }, null, 8, _hoisted_20),
            _hoisted_21
          ]),
          _createElementVNode("li", _hoisted_22, [
            _createElementVNode("div", {
              class: "targets__img",
              innerHTML: getIcon( 'award')
            }, null, 8, _hoisted_23),
            _hoisted_24
          ]),
          _createElementVNode("li", _hoisted_25, [
            _createElementVNode("div", {
              class: "targets__img",
              innerHTML: getIcon( 'heartHand')
            }, null, 8, _hoisted_26),
            _hoisted_27
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_28, [
      _createElementVNode("div", _hoisted_29, [
        _hoisted_30,
        _createVNode(MemberListRVWA, { members: _unref(members) }, null, 8, ["members"])
      ])
    ])
  ]))
}
}

})